<template>
  <div class="account-settings-wrapper">
    <h2 class="title">Account Settings</h2>

    <b-tabs class="content-wrapper">
      <b-tab-item label="Account Information">
        <account-shipper v-if="isShipper" ></account-shipper>
        <account-carrier v-if="isCarrier" ></account-carrier>
      </b-tab-item>

      <b-tab-item label="Activity" v-if="isShipper">
        <div class="columns">
          <div class="column is-one-third">
            <shipper-metrics :company-key="currentCompanyInfo.companyKey" />
          </div>

          <div class="column is-one-third middle-column">
            <shipper-activity-by-carrier :company-key="currentCompanyInfo.companyKey" />
          </div>

          <div class="column is-one-third">
            <h4 class="title" style="font-size: 1.2rem">Carrier Ranking</h4>
            <br/>
            Coming soon
          </div>

        </div>
      </b-tab-item>
    </b-tabs>
  </div>
</template>

<script>
import AccountShipper from '@/components/Profile-and-settings/Shipper'
import AccountCarrier from '@/components/Profile-and-settings/Carrier'
import ShipperMetrics from '@/components/Profile-and-settings/Metrics/ShipperActivity'
import ShipperActivityByCarrier from '@/components/Profile-and-settings/Metrics/ShipperActivityByCarrier'

import { mapState, mapGetters } from 'vuex'

export default {
  name: 'AccountSettings',

  components: {
    AccountShipper,
    AccountCarrier,
    ShipperMetrics,
    ShipperActivityByCarrier
  },

  computed: {
    ...mapState('company', ['currentCompanyInfo']),
    ...mapGetters('user', ['isFactoring', 'isShipper', 'isCarrier', 'isCompanyAdmin', 'isTrucklAdmin'])
  }
}
</script>

<style scoped lang="scss">
.account-settings-wrapper {
  min-height: 85vh;
  &::after {
    // TODO: this would be great as a mix-in
    content: '';
    background-image: url('../assets/backgrounds/hannes-egler-360942-unsplash.jpg');
    background-size: cover;
    background-repeat: no-repeat;
    opacity: 0.4;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    position: fixed;
    z-index: -1;
  }
}

.content-wrapper {
  background: rgba(255, 255, 255, 0.7);
  padding: 15px;
}

.middle-column {
  border-right: 1px solid blue;
  border-left: 1px solid blue;
}
</style>
